"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CheckboxView = function CheckboxView(_ref) {
  var includeSelectedIds = _ref.includeSelectedIds,
    toggleSelectAll = _ref.toggleSelectAll,
    Ids = _ref.Ids;
  return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    padding: "checkbox"
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      color: "primary",
      indeterminate: includeSelectedIds,
      checked: includeSelectedIds,
      onChange: function onChange(event) {
        return toggleSelectAll(event, Ids, includeSelectedIds);
      }
    })
  }));
};
var _default = CheckboxView;
exports.default = _default;